import firebase from "firebase";
var firebaseConfig = {
  apiKey: "AIzaSyDXMgHuS4H_aZLXwUJ8Tj7t39U1DdgApqY",
  authDomain: "airender-login-b67b8.firebaseapp.com",
  databaseURL: "https://airender-login-b67b8.firebaseio.com",
  projectId: "airender-login-b67b8",
  storageBucket: "airender-login-b67b8.appspot.com",
  messagingSenderId: "463641889157",
  appId: "1:463641889157:web:4e7d3de4ec8a0052915cec",
};
const fire = firebase.initializeApp(firebaseConfig);
export default fire;